import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { ExpertReportDecisionDialogWrapper } from 'containers/CourtManagerLegalProceedings/ExpertReport/styled-components';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import { Config, Listings } from 'containers/AppContainer/typings';
import { LISTINGS } from 'containers/data-structure';
import {
  COMPTABLE_EXPERTISE_ID,
  MECHANICAL_EXPERTISE_ID,
  MEDICAL_EXPERTISE_ID,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';

export interface ContestationDialogProps {
  listings?: Listings;
  intl: IntlShape;
  contestationReasons: Set<unknown>;
  civilJudgementMedicalExpertiseId: number | undefined;
  civilJudgementAccountingExpertiseId: number | undefined;
  civilJudgementMechanicalExpertiseId: number | undefined;
  setContestationReasons: Function;
  civilJudgementId: number;
  expertiseType: string;
  isOpen: boolean;
  setIsContestationDialogOpen: Function;
}

export const ContestationDialog: React.FC<ContestationDialogProps> = ({
  listings,
  civilJudgementMedicalExpertiseId,
  expertiseType,
  civilJudgementAccountingExpertiseId,
  civilJudgementMechanicalExpertiseId,
  contestationReasons: contestationReasonsSet,
  setContestationReasons: contestationSetSetter,
  civilJudgementId,
  isOpen,
  setIsContestationDialogOpen,
  ...props
}): JSX.Element => {
  const [contestationReasons, setContestationReasons] = useState<Set<number>>(
    new Set(),
  );

  const handleCancelContestation = () => {
    setIsContestationDialogOpen(false);
    setContestationReasons(new Set());
  };
  // testing checkbox is not working in react testing library, to analyze
  /* istanbul ignore next */
  const handleValidateContestation = () => {
    setIsContestationDialogOpen(false);
    if (expertiseType === MEDICAL_EXPERTISE_ID) {
      contestationSetSetter(
        new Set(contestationReasonsSet).add({
          civilJudgementId,
          civilJudgementMedicalExpertiseId,
          contestationReasons,
          instruction,
        }),
      );
    }
    if (expertiseType === COMPTABLE_EXPERTISE_ID) {
      contestationSetSetter(
        new Set(contestationReasonsSet).add({
          civilJudgementId,
          civilJudgementAccountingExpertiseId,
          contestationReasons,
          instruction,
        }),
      );
    }
    if (expertiseType === MECHANICAL_EXPERTISE_ID) {
      contestationSetSetter(
        new Set(contestationReasonsSet).add({
          civilJudgementId,
          civilJudgementMechanicalExpertiseId,
          contestationReasons,
          instruction,
        }),
      );
    }
    setContestationReasons(new Set());
  };

  const handleContestationReasonChangeCheckBox = (id: number) => (
    e: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    const contestationReasonSet = new Set(contestationReasons);
    if (e.target.checked) {
      contestationReasonSet.add(id);
    } else {
      /* istanbul ignore next */
      contestationReasonSet.delete(id);
    }
    setContestationReasons(contestationReasonSet);
  };

  const isContestationReasonChecked = (id: number) =>
    contestationReasons.has(id);

  const [instruction, setInstruction] = useState<string>('');

  const handleInstructionChange = (e: React.ChangeEvent<{ value: string }>) => {
    setInstruction(e.target.value);
  };

  return (
    <>
      <ExpertReportDecisionDialogWrapper
        className="refusal-content"
        handleValidate={handleValidateContestation}
        handleClose={handleCancelContestation}
        title={translate(messages.contestationDialogTitle, props)}
        cancelTitle={translate(messages.contestationDialogCancel, props)}
        confirmTitle={translate(messages.contestationDialogValidate, props)}
        open={isOpen}
        validateButtonDisabled={isEmpty(contestationReasons)}
      >
        {get(
          listings,
          LISTINGS.JUDGEMENT_ON_MERITS_CONTESTATION_REASONS,
          [],
        ).map((contestationReason: Config, index: number) => (
          <FormControlLabel
            key={index}
            control={
              <Checkbox
                data-testid={`checkbox-${index}`}
                checked={isContestationReasonChecked(contestationReason.id)}
                color="primary"
                onChange={handleContestationReasonChangeCheckBox(
                  contestationReason.id,
                )}
              />
            }
            label={contestationReason.title}
          />
        ))}
        <div>
          <TextField
            id="instruction_field"
            label={translate(
              messages.contestationDialogInstructionFieldTitle,
              props,
            )}
            onChange={handleInstructionChange}
            value={instruction}
          />
        </div>
      </ExpertReportDecisionDialogWrapper>
    </>
  );
};

export default injectIntl(ContestationDialog);
